let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("evtN0")).then(() => parcelRequire('iVOG8'));